/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TriggerEnvRequirement,
  TriggerEnvRequirement$inboundSchema,
} from "./triggerenvrequirement.js";

/**
 * The ingress kind for the trigger definition.
 */
export const TriggerDefinitionKind = {
  Webhook: "webhook",
  Schedule: "schedule",
} as const;
/**
 * The ingress kind for the trigger definition.
 */
export type TriggerDefinitionKind = ClosedEnum<typeof TriggerDefinitionKind>;

export type TriggerDefinition = {
  /**
   * JSON schema describing the trigger config.
   */
  configSchema: string;
  /**
   * Description of the trigger definition.
   */
  description: string;
  /**
   * Environment variables required by this trigger definition.
   */
  envRequirements: Array<TriggerEnvRequirement>;
  /**
   * The ingress kind for the trigger definition.
   */
  kind: TriggerDefinitionKind;
  /**
   * The trigger definition slug.
   */
  slug: string;
  /**
   * The trigger definition title.
   */
  title: string;
};

/** @internal */
export const TriggerDefinitionKind$inboundSchema: z.ZodMiniEnum<
  typeof TriggerDefinitionKind
> = z.enum(TriggerDefinitionKind);

/** @internal */
export const TriggerDefinition$inboundSchema: z.ZodMiniType<
  TriggerDefinition,
  unknown
> = z.pipe(
  z.object({
    config_schema: z.string(),
    description: z.string(),
    env_requirements: z.array(TriggerEnvRequirement$inboundSchema),
    kind: TriggerDefinitionKind$inboundSchema,
    slug: z.string(),
    title: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "config_schema": "configSchema",
      "env_requirements": "envRequirements",
    });
  }),
);

export function triggerDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<TriggerDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TriggerDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TriggerDefinition' from JSON`,
  );
}
